exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".events-index .inside-content .main-col .teasers .teaser h3{margin-bottom:0}.events-index .serie{align-items:center}.events-index .serie .reserve{margin-left:25px}", ""]);

// exports
